import React from 'react'
import PropTypes from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import yn from 'yn'

const BoxOnboardingLink = ({ login, location: { search } }) => {
  const isOnboardingLinkDisabled = yn(process.env.RAZZLE_ONBOARDING_ENABLED_DISABLE_ONBOARDING_LINK)
  if (isOnboardingLinkDisabled) { 
    return null
  } else {
    return (
      <div className='col-12 col-md-12 txt-center mt-2 px-0'>
        <div className='row align-items-center'>
          <div className='col-12 txt-left'>
            <p className='txt-body-sm'>
              <Link
                className='txt-body-sm color-brand-2 txt-underline btn-not-my-email'
                to={{
                  pathname: '/recovery',
                  state: {
                    login: login
                  },
                  search: search
                }}>
                opps, este não é o meu e-mail
              </Link>
            </p>
          </div>
        </div>
      </div>
    )
  }
}

BoxOnboardingLink.propTypes = {
  login: PropTypes.string,
  location: PropTypes.shape({
    search: PropTypes.string
  })
}

export default withRouter(BoxOnboardingLink)
